import { Fetcher } from "@/utils/fetcher";

const warehouse = new Fetcher("warehouse");

export interface WarehouseItem {
  id: number;
  name: string;
  slug: string;
  type: string;
  address: string;
  code: string;
  status?: string;
}

interface WarehouseListResponse {
  Success: boolean;
  Message: string;
  Data: WarehouseItem[];
}

export const getWarehouseList = ({
  page = 0,
  limit = 1000,
  searchFor = null,
  status = null,
  type = null,
}: {
  page?: number;
  limit?: number;
  searchFor?: string | null;
  status?: string | null;
  type?: string | null;
} = {}): Promise<WarehouseListResponse> =>
  warehouse.post<WarehouseListResponse>("/list", {
    page,
    limit,
    searchFor,
    status,
    type,
  });
